// extracted by mini-css-extract-plugin
export default {"loader":"AssessmentLoadingScreen_loader__4AkHC","zoomText":"AssessmentLoadingScreen_zoomText__wytP9"};